export default __webpack_public_path__ + "assets/images/d1087fa8e9ad729f12a3b0167617f676.png";